export default "__VITE_ASSET__DSGqg$ws__"